module.exports = __webpack_public_path__ + "img/history-banner_03.60af82b8.png";